<template>
  <div class="container">
    <RowItem
      :isOneLine="true"
      class="row-item"
      label="Email"
      format="text"
      id="email"
      @input_value="setValue($event, 'email')"
    />
    <RowItem
      :isOneLine="true"
      class="row-item"
      style="margin-top: 5%"
      label="Password"
      format="password"
      id="password"
      @input_value="setValue($event, 'password')"
    />

    <p style="color:red">{{error}}</p>

    <div class="button-extra">
      <Button text="Login" @clicked="login" />
    </div>
  </div>
</template>

<script>
import RowItem from "../components/RowItem.vue";
import Button from "../components/ButtonItem.vue";

import auth_methods from "../Database/auth.js";

export default {
  components: {
    RowItem,
    Button,
  },

  data: () => {
    return {
      email: null,
      password: null,
      error: "",
    };
  },

  async created() {},

  methods: {
    setValue(value, attr) {
      this[attr] = value;
    },

    async login() {

      if (await auth_methods.login(this.email, this.password)) {
        this.email = null;
        this.password = null;
      } else {
          this.error = "Verkeerde inloggegevens!"
      }
    },
  },
};
</script>

<style>
.container {
  display: flex;
  align-content: center;
  flex-direction: column;
  justify-content: center;
  background-color: #2c3e50;
  padding: 5%;
  border-radius: 28px;
}
</style>